<div class="registration-closed-container">
    <div class="registration-message">
        <h3 class="registration-title">Registrations Opening Soon!</h3>
        <p class="registration-date">
            Applications will open on <strong>{{ registrationOpenDate }}</strong> at 00:00 UTC+2
        </p>
    </div>
</div>